import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import NewsletterConsentImage from 'assets/images/popup-newsletter-consent.png';
import UserService from 'services/user.service';
import AuthService from "services/auth.service";

function NewsletterConsentModal() {
  const currentUser = AuthService.getCurrentUser();
  const [show, setShow] = useState(true);

  const handleOption = (enabled) => {
    const dismiss = () => {
      localStorage.setItem(`newsletter-consent-prompt:seen:${currentUser.id}`, true);
      setShow(false);
    };
    UserService.marketingEmail(currentUser.id, enabled).then(
      dismiss, dismiss 
    );
  };

  return (
    <div>
      <Modal
        className="modal-overlay pop-up-modal"
        size="l"
        show={show}
        onHide= {() => setShow(false)}
        centered
      >
        <Modal.Body>
          <div>
            <div className="title">Want to stay updated?</div>
            <div className="description">
              Receive newsletter, updates, health tips, and promotional offers from BookDoc via email. You can manage this anytime in <i>My Profile</i>. Read our 
              <Link to= "/eb/privacy" target="_blank" rel="noreferrer" className="highlighted" >{" "} Privacy Policy.</Link>
            </div>
            <div>
              <img
                src={NewsletterConsentImage}
                alt="newsletter-consent-image"
                className="center pt-6"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flex-column button-footer">
          <button
            className="btn btn-link download-button"
            onClick={() => handleOption(true)}
          >
            <>Yes, Keep Me Updated</>
          </button>
          <button
            className={"btn btn-link later-button"}
            onClick={() => handleOption(false)}
          >
            <>No, Thanks</>
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default NewsletterConsentModal;
